import { Grid, Typography } from "@mui/material";
import React from "react";

import PercentageStat from "../PercentageStat";

import { convertToCurrency } from "utils/string";

const RevenueStat = ({ data }) => {
  return (
    <Grid container flex={1} alignItems="center" justifyContent="space-between">
      <Grid item>
        <Typography variant="h5" style={{ fontWeight: 700 }}>
          {convertToCurrency(data?.currentMonthRevenue ?? 0)}
        </Typography>
        <Typography paragraph style={{ color: "#757575", fontSize: "14px" }}>
          {convertToCurrency(data?.previousMonthRevenue ?? 0)} in last month
        </Typography>
      </Grid>
      <Grid item>
        <PercentageStat value={data?.differencePercentage} />

        <Typography paragraph style={{ color: "#757575", fontSize: "14px" }}>
          vs last month
        </Typography>
      </Grid>
    </Grid>
  );
};

export default RevenueStat;
